import { apiClient } from '@/core/api/client';
import { Endpoints } from '@/core/api/endpoints';
import type {
  GuestProjectsQueryParams,
  GuestProjectsResponse,
} from '@/core/api/models/guestProjects';
import { getAdhaBasicAuthHeaders } from '@/core/constants/adhaJourney';
import { logger } from '@/core/logger';

/**
 * Guest /v1/projects page size — first paint + each background page until complete.
 * Keep small for fast first paint; remaining pages load in the background.
 */
export const GUEST_PROJECTS_PAGE_SIZE = 20;

/** Same as {@link GUEST_PROJECTS_PAGE_SIZE}, but for native (iOS/Android). */
export const GUEST_PROJECTS_PAGE_SIZE_MOBILE = 20;

/**
 * Contentful guest-tag `propertyImages` page size (independent of listing API).
 */
export const GUEST_CONTENTFUL_PAGE_SIZE = 200;

/** Card shimmers while fetching the next page — keep small (not tied to page size). */
export const GUEST_PROJECTS_NEXT_PAGE_SKELETON_COUNT = 10;

/**
 * Public guest catalogue — GET /v1/projects (Basic Auth).
 * Used by guest list + details/explore (paginated source list).
 */
export class GuestProjectsService {
  async getProjects(
    params: GuestProjectsQueryParams = {},
  ): Promise<GuestProjectsResponse> {
    const page = params.page ?? 0;
    const limit = params.limit ?? GUEST_PROJECTS_PAGE_SIZE;
    logger.info('GuestProjectsService:Fetching projects', { page, limit });
    return apiClient.get<GuestProjectsResponse>(Endpoints.property.projects, {
      headers: getAdhaBasicAuthHeaders(),
      params: { page, limit },
    });
  }
}

export const guestProjectsService = new GuestProjectsService();
